import { infoApi } from '@shared/info-api-config';
import _ from '@luna/lodash';
import { appointments } from '@retail/appointments-config';
import { contactDataManagement } from '@shared/contact-data-management-config';
import { cards } from '@retail/cards-config';
import { overview } from '@retail/overview-config';
import { kyc } from '@retail/kyc-config';
import { messenger } from '@shared/messenger-config';
import { plugins } from '@retail/plugins-config';
import {
    AccountsCurrentFeatureConfig,
    AccountsFeatureConfig,
    BuildingSocietyFeatureConfig,
    ProductsFeatureConfig,
    SavingsFeatureConfig,
    StatementFeatureConfig,
} from '@retail/products-config';
import { thirdPartyProviders } from '@shared/third-party-providers-config';
import { exportFeatures, transactions } from '@retail/transactions-config';
import { supportChatFeatureConfigMap } from '@shared/support-chat-config';
import { securitySettings } from '@shared/security-settings-config';
import type { DateFormat } from '@luna/date';
import { documentsAndRequests } from '@shared/documents-and-requests-config';

import { arrayOverwrite, baseFeatureConfig, extendFeatureConfigFromUrl } from './base';
import type { PartialRetailFeatureConfig } from './featureConfig';

export const countryFeatures: PartialRetailFeatureConfig = {
    handover: {
        handoverTokenExchange: true,
        sso: true,
    },
    appointments: appointments.RO,
    contactDataManagement: contactDataManagement.RO,
    documentsAndRequests: documentsAndRequests.RO,
    kyc: kyc.RO,
    messenger: messenger.RO,
    cards: cards.RO,
    overview: overview.RO,
    plugins: plugins.RO,
    statements: StatementFeatureConfig.RO,
    thirdPartyProviders: thirdPartyProviders.RO,
    transactions: transactions.RO,
    export: exportFeatures.RO,
    savings: SavingsFeatureConfig.RO,
    supportChat: supportChatFeatureConfigMap.RO,
    securitySettings: securitySettings.RO,
    base: {
        country: 'RO',
        newAccountModel: true,
        ibanCountryCode: 'RO',
        intrabankIbanMatch: /(\s*)(RO)(..)(\s*)(RNCB)(.*?)/.toString(),
        defaultLanguage: 'ro',
        allowedLanguages: ['en', 'ro'],
        availableLanguages: ['en', 'ro', 'en-RW'],
        defaultDateFormatVerbose: 'd MMMM yyyy' as DateFormat,
        defaultCurrency: 'RON',
        defaultCurrencySign: 'RON',
        mainProductAmount: 'disposable',
        loanProductAmount: 'balance',
        defaultCurrencyPre: false,
        thousandSeparator: ' ',
        sendLanguageHeader: true,
        unauthorizedStatusCode: '403',
        useVersionHeaders: false,
        latestVersionHeader: null,
        doPreCurrencyCheck: false,
        defaultTimezone: 'Europe/Bucharest',
        languageOverrides: {
            en: 'en-RW',
        },
    },
    footer: {
        links: {
            privacy: {
                ro: 'https://www.bcr.ro/george/ro/bmenu3',
                en: 'https://www.bcr.ro/george/en/bmenu3',
            },
            termsAndConditions: {
                ro: 'https://www.bcr.ro/george/ro/bmenu2',
                en: 'https://www.bcr.ro/george/en/bmenu2',
            },
        },
    },
    accounts: AccountsFeatureConfig.RO,
    currentAccount: AccountsCurrentFeatureConfig.RO,
    buildingSociety: BuildingSocietyFeatureConfig.RO,
    settings: {
        changePassword: false,
        saveLanguageInUppercase: false,
    },
    infoApi: infoApi.RO,
    devTools: {
        availableEnvironments: {
            Local: 'http://localhost:8080',
            Dev: 'https://ro.dev.beeone.at',
            FAT: 'https://george.fat.bcr.ro',
            UAT: 'https://george.uat.bcr.ro',
        },
    },
    tracking: {
        appId: 'INT84',
        appName: 'GeorgeWeb_Retail_RO',
        instituteId: 785,
    },
    products: ProductsFeatureConfig.RO,
    allowedRedirectDomains: ['bcr.ro'],
};

const featureConfigWithBase = _.merge({}, baseFeatureConfig, countryFeatures, arrayOverwrite);
export const featureConfig = extendFeatureConfigFromUrl(featureConfigWithBase);
